import React from "react"
import { useTranslation } from "react-i18next"
import { useAppDispatch, useAppSelector } from "../../../hooks"
import { lobbyTeamLeave } from "../../../stores/NetworkStore"
import PokemonPortrait from "../pokemon-portrait"
import "./lobby-team-widget.css"

export function LobbyTeamWidget() {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const teammate = useAppSelector((state) => state.lobby.lobbyTeammate)

  if (!teammate) return null

  return (
    <div className="lobby-team-widget">
      <span className="lobby-team-label">{t("your_team")}</span>
      <PokemonPortrait avatar={teammate.avatar} className="lobby-team-avatar" />
      <span className="lobby-team-name">{teammate.name}</span>
      <button
        className="bubbly red lobby-team-leave"
        onClick={() => dispatch(lobbyTeamLeave())}
      >
        {t("leave_team")}
      </button>
    </div>
  )
}
